var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{class:( _obj = {}, _obj[_vm.emphasizedClass] = _vm.isEmphasized, _obj )},[_vm._v(" "+_vm._s(_vm._f("numberWithComma")(_vm._f("emptyFormat")(_vm.value)))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }